import { isRoot } from "utils/treeUtils";

export const getPath = (n, list = []) => {
  if (isRoot(n.data)) {
    return list.reverse().join("\\");
  }
  return getPath(n.parent, [...list, n.data.folderName]);
};
